import {is_numeric} from '../../../Helpers/js/simple.functions';
import $ from 'jquery';
import LP from '../0-lp';
import UI from '../0-ui';

LP.dlgExportResults = {
    exporting: false,
    prepare: function (selector, options) {
        //make sure that only one click event listener is attached and only ONE modal opens. Otherwise closing of dialog won't work properly
        $(selector).off('click').on('click', function () {
            var $this = $(this);
            if ($this.is('[disabled]')) {
                return false;
            }
            var url = $this.attr('url');
            // var width = 650;
            // var height = 430;
            var width = 800;
            var height = 600;
            var params = '';
            if ($this.attr('poll')) {
                params += '&poll=' + $this.attr('poll');
            }
            if ($this.attr('question')) {
                params += '&question=' + $this.attr('question');
                height = 600;
            }
            if ($this.attr('stat')) {
                params += '&stat=' + $this.attr('stat');
                height = 600;
            }
            if ($this.attr('mode') === 'summaries') {
                height = 600;
            }
            LP.Dialog.open($.extend(options, {
                name: 'exportResults',
                ajax: url,
                request: params,
                title: this.title,
                width: width,
                minHeight: height,
                maxHeight: height * 1.3,
                sizeable: false,
                onLoad: LP.dlgExportResults.initDialog,
                submit: LP.dlgExportResults.exportResults
            }));
            return false;
        });
    },

    initDialog: function () {
        $('#export_profile').change(function () {

            var profile = $(this).val();
            if (profile === 'CSV' || profile === 'TXT') $('#csv_options').show(); else $('#csv_options').hide();

            var option = $('option[value="' + profile + '"]', this);

            if (option.attr('charts') === '1') {
                var onlyCharts = $('#only_charts');

                $('#export_with_charts').show();
                $('#disable_charts').prop('checked', false);
                $('#enable_charts').prop('checked', true);

                onlyCharts.prop('checked', false);
                if (option.attr('onlyCharts')) {
                    onlyCharts.parent().show();
                } else {
                    onlyCharts.parent().hide();
                }
            } else {
                $('#export_with_charts').hide();
            }

            if (profile === 'Xlsx') {
                $('#export_on_pages').show();
            } else {
                $('#export_on_pages').hide();
            }

            if (profile === 'SPSS') {
                $('#disable_codings').prop('checked', false).attr('disabled', '1');
                $('#no_codings_label').addClass('disabled');

                $('#enable_codings').prop('checked', true);
                $('#coding_options').show();
            } else {
                $('#disable_codings').removeAttr('disabled');
                $('#no_codings_label').removeClass('disabled');
            }
        });
    },

    /*onChangeProfile : function() {
     var profile = $(this).val();

     if (profile=='user') { $('.userValue').show(); $('#delimiter').removeAttr('disabled'); $('#linefeed').removeAttr('disabled'); }
     else { $('.userValue').hide(); $('#delimiter').attr('disabled','1');  $('#linefeed').attr('disabled','1'); }

     if (profile=='spss') { $('#exportVarnames').hide(); $('#exportCodings').hide(); }
     else { $('#exportVarnames').show(); $('#exportCodings').show();  }
     },*/

    exportResults: function () {
        var submitBtn = $('.ui-dialog .submit');
        submitBtn.attr('disabled', '1');

        var correct = true;
        var isSPSS = $('#spss_syntax').is(':checked');
        var useCodings = $('#useExportCoding').is(':checked');
        var notAnswered = $('#notAnswered');
        var missValue = $('#missValue');

        if (notAnswered.length > 0) {

            if (isSPSS && !notAnswered.val())	// Nicht-Beantworted muss in SPSS angegeben sein
            {
                correct = false;
            } else								    // Nicht-Beantworted muss Zahl in SPSS sein, oder wenn Kodierung verwendet wird
            if (isSPSS || useCodings) {
                correct = is_numeric(notAnswered.val());
            }

            if (!correct) {
                UI.showMsgBox($('#invalidNotAnsweredValue').html());
                submitBtn.removeAttr('disabled');
                return;
            }
        }

        if (missValue) {
            if (isSPSS && !missValue.val()) // Missing-Value muss in SPSS angegeben sein
            {
                correct = false;
            } else								  // Missing-Value muss eine Zahle sein (oder Leer wenn nicht SPSS)
            {
                correct = is_numeric(missValue.val()) || (!isSPSS && !missValue.val());
            }

            if (!correct) {
                UI.showMsgBox($('#invalidMissValue').html());
                submitBtn.removeAttr('disabled');
                return;
            }
        }

        if (correct) {
            var form = $('#exportResult');
            var url = form.attr('action');

            var onSuccess = function (json) {
                window.addTask(json.task, {closeAfter: 0});
            };

            window.Browser.send(url, form.serialize(), onSuccess);
            LP.Dialog.close();
        }
        return correct;
    }
};